import CommunityList from './CommunityList';

export default CommunityList;